import React from 'react';
import classNames from 'classnames';
import { useFilterId } from '../../hooks/useFilterId';

export interface TabProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  tabProps?: React.HTMLAttributes<HTMLButtonElement>;
}

const Tab: React.FC<TabProps> = ({ tabProps, label, className, ...props }) => {
  const id = useFilterId(label);

  return (
    <div
      id={`panel-${id}`}
      role="tabpanel"
      aria-labelledby={`tab-${id}`}
      className={classNames(className, 'ui-tabs-content')}
      {...props}
    />
  );
};

export default Tab;
